import Section from "../Section/Section";
import { useTranslation } from "react-i18next";
import { licences } from "../../constants/licence";

import { GridContainer } from "./LicencesSection.styled";
import LicenceCard from "../LicenceCard/LicenceCard";
import useDevice from "../../hooks/useDevice";
import styled from "styled-components";
const i18nKey = "pages.licence";

const HorizontalLine = styled.hr`
  grid-column: 1 / -1;
  width: 100%;
  border: none;
  border-top: 1px solid #6E6353;
  margin: 40px 0;
  @media (max-width: 600px) {
    margin: 0 0 40px 0;
  }
`;
const LicencesSection = () => {
  const { t } = useTranslation();
  const { isDesktop, isTablet, isMobile } = useDevice();
  const sectionStyle = isMobile || isTablet ? { gap: "20px" } : {gap: "52px"};
  const columns = isDesktop ? 3 : isTablet ? 2 : isMobile ? 1 : 1;
  return (
    <Section
      withBackgroundImg={false}
      header={i18nKey ? t(`${i18nKey}.title`) : ""}
      sectionStyle={sectionStyle}
    >
      <GridContainer>
        {licences.flatMap((licence, idx) => {
          const isLastColumn = (idx + 1) % columns === 0;
          const isLastRow =
            idx >= licences.length - (licences.length % columns || columns);
          const card = (
            <LicenceCard
              key={licence.id}
              imageUrl={licence.imageUrl}
              title={licence.title}
              pdfLink={licence.pdfLink}
              isLastColumn={isLastColumn}
              isLastRow={isLastRow}
            />
          );

          if ((idx === 2 || idx === 5) && idx < licences.length - 1) {
            return [card, <HorizontalLine key={`hr-${idx}`} />];
          }

          return [card];
        })}
      </GridContainer>
    </Section>
  );
};

export default LicencesSection;
